module.exports = __webpack_public_path__ + "static/img/watches.990cb1b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cover/watches.jpg
// module id = zLMK
// module chunks = 1